import {ISubmissionProps} from '@/containers/FdcMilanoVolunteers/resources/submission';

export const getIndicators = (submissions: ISubmissionProps[]) => {
    const values = {
        total: 0,
        silverSenior : 0,
        universityStudent  : 0,
        workers : 0,
    }

    submissions.forEach(submission => {
        values.total++;

        if (submission.domanda22 < 1964) {
            values.silverSenior++;
        }

        if (submission.domanda25 === '4') {
            values.universityStudent++;
        }

        if ( submission.domanda25 === '1' && submission.domanda26 === '4' && submission.domanda28 === '1') {
            values.workers++;
        }
    })

    return Object.values(values);
}